module.exports = __webpack_public_path__ + "static/media/Turma-da-Arca_front-cover.5e72af5b.jpg";